<template>
  <div class="bg-white rounded-lg border border-gray-200 shadow-sm py-3 px-3 mb-4">
    <!-- Header -->
    <div class="mb-2 flex items-center justify-between gap-2">
      <h3 class="text-sm font-semibold text-black">Filtrer la liste</h3>
      <button
        type="button"
        class="flex items-center gap-1 text-xs font-medium text-black px-2 py-1 border border-gray-300 rounded md:hidden"
        @click="isCollapsed = !isCollapsed"
      >
        <i :class="isCollapsed ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
        {{ isCollapsed ? 'Afficher' : 'Masquer' }}
      </button>
    </div>

    <!-- Content collapsible on mobile -->
    <div v-show="!isCollapsed">
      <form @submit.prevent class="space-y-2 pt-2">
      <div
          class="grid grid-cols-2 gap-2 md:grid-cols-4 lg:grid-cols-9"
      >
        <div class="w-full">
          <label class="block text-xs font-medium text-gray-700 mb-0.5">
            Référence
          </label>
          <input
              v-model.trim="filters.reference"
              type="text"
              placeholder="Rechercher par référence"
              class="w-full px-3.5 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>

        <div class="w-full">
          <label class="block text-xs font-medium text-gray-700 mb-0.5">
            Marque
          </label>
          <select
              v-model="filters.marque"
              class="w-full px-3.5 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
              :disabled="brands.length === 0"
          >
            <option value="">{{ brands.length === 0 ? 'Chargement...' : 'Toutes les marques' }}</option>
            <option
                v-for="marque in brands"
                :key="marque.number || marque.id"
                :value="marque.name"
            >
              {{ marque.name }}
            </option>
          </select>
        </div>

        <div class="w-full md:flex-1">
          <label class="block text-xs font-medium text-gray-700 mb-0.5">
            Collection
          </label>
          <select
              v-model="filters.collection"
              class="w-full px-3.5 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
          >
            <option value="">Toutes les collections</option>
            <option
                v-for="collection in collections"
                :key="collection.id_collection"
                :value="collection.libelle"
            >
              {{ collection.libelle }}
            </option>
          </select>
        </div>

<!--
        <div v-if="!categoriesTree" class="w-full md:flex-1">
          <label class="block text-xs font-medium text-gray-700 mb-0.5">
            Catégories
          </label>
          <select
              v-model="filters.categories"
              class="w-full px-3.5 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
          >
            <option value="">Toutes les catégories</option>
            <option
                v-for="cat in categoryOptions"
                :key="cat.id_categorie"
                :value="cat.id_categorie"
            >
              {{ cat.label }}
            </option>
          </select>
        </div>

        <template v-else>
          <div class="w-full md:flex-1">
            <label class="block text-xs font-medium text-gray-700 mb-0.5">
              Catégorie
            </label>
            <select
                v-model="filters.catLevel1Id"
                class="w-full px-3.5 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
            >
              <option value="">Toutes</option>
              <option
                  v-for="cat in level1Options"
                  :key="cat.id_categorie"
                  :value="cat.id_categorie"
              >
                {{ cat.label }}
              </option>
            </select>
          </div>
        </template>
-->

        <div class="w-full md:flex-1">
          <label class="block text-xs font-medium text-gray-700 mb-0.5">
            Statut
          </label>
          <select
              v-model="filters.statut"
              class="w-full px-3.5 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
          >
            <option value="">Tous les statuts</option>
            <option value="en-vente">En vente</option>
            <option value="hors-ligne">Hors ligne</option>
            <option value="rupture">Rupture</option>
          </select>
        </div>

        <div class="w-full md:flex-1">
          <label class="block text-xs font-medium text-gray-700 mb-0.5">
            Remise
          </label>
          <select
              v-model="filters.remise"
              class="w-full px-3.5 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
          >
            <option value="">Tous les produits</option>
            <option value="remise">Produits remisés</option>
            <option value="plein-tarif">Hors remise</option>
          </select>
        </div>

        <div class="w-full md:flex-1">
          <label class="block text-xs font-medium text-gray-700 mb-0.5">
            Prix min
          </label>
          <input
              v-model.number="filters.prixMin"
              type="number"
              placeholder="0"
              class="w-full px-3.5 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>

        <div class="w-full md:flex-1">
          <label class="block text-xs font-medium text-gray-700 mb-0.5">
            Prix max
          </label>
          <input
              v-model.number="filters.prixMax"
              type="number"
              placeholder="1000"
              class="w-full px-3.5 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>

        <div class="w-full md:flex-1">
          <label class="block text-xs font-medium text-gray-700 mb-0.5">
            Date début
          </label>
          <input
              v-model="filters.dateFrom"
              type="date"
              class="w-full px-3.5 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>

        <div class="w-full md:flex-1">
          <label class="block text-xs font-medium text-gray-700 mb-0.5">
            Date fin
          </label>
          <input
              v-model="filters.dateTo"
              type="date"
              class="w-full px-3.5 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>
      </div>

      <!-- Tri -->
      <div class="flex items-center gap-3 pt-1">
        <label class="text-xs font-medium text-gray-700">Trier par</label>
        <div class="flex gap-2">
          <button
            type="button"
            :class="[
              'px-3 py-1 text-xs font-medium rounded border transition-colors',
              filters.tri === 'date'
                ? 'bg-indigo-600 text-white border-indigo-600'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
            ]"
            @click="filters.tri = 'date'"
          >
            <i class="fas fa-calendar-alt mr-1"></i>Date
          </button>
          <button
            type="button"
            :class="[
              'px-3 py-1 text-xs font-medium rounded border transition-colors',
              filters.tri === 'alphabet'
                ? 'bg-indigo-600 text-white border-indigo-600'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
            ]"
            @click="filters.tri = 'alphabet'"
          >
            <i class="fas fa-sort-alpha-down mr-1"></i>Alphabet
          </button>
        </div>
      </div>

      <!-- Bouton réinitialiser -->
      <div class="flex justify-end pt-1 pb-2">
        <button 
          v-if="hasActiveFilters"
          type="button"
          @click="clearFilters"
          class="inline-flex items-center px-3.5 py-1 text-xs font-medium rounded text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-red-500"
        >
          <i class="fas fa-undo mr-1 text-xs"></i>
          Réinitialiser
        </button>
      </div>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive, ref, computed, watch, onMounted, onUnmounted } from 'vue'
import type { Filters, ProduitCatalogue, CategorieNode } from '@/types'
import { getVendeurMarques } from '@/api/brands'
import type { Brand } from '@/types/brand'
import { getCollections } from '@/api/collections'
import type { CollectionOption } from '@/api/collections'
import { useAuthStore } from '@/stores/auth'

interface Props {
  products: ProduitCatalogue[]
  categoryOptions?: { id_categorie: number; label: string }[]
  categoriesTree?: CategorieNode[]
  // New: allow parent to pass initial filters (for server-side filtering + URL sync)
  initialFilters?: Partial<Filters>
}

interface Emits {
  (e: 'update:filtered-products', products: ProduitCatalogue[]): void
  // New: emit current filter criteria so parent can perform server-side filtering
  (e: 'filter', filters: Filters): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const isFiltering = ref(false)
const isCollapsed = ref(true)
const brands = ref<Brand[]>([])
const collections = ref<CollectionOption[]>([])
const authStore = useAuthStore()
const filters = reactive<Filters>({
  reference: '',
  marque: '',
  collection: '',
  categories: '',
  catLevel1Id: '',
  catLevel2Id: '',
  catLevel3Id: '',
  prixMin: '',
  prixMax: '',
  statut: '',
  dateFrom: '',
  dateTo: '',
  tri: 'date',
  remise: ''
})

const level1Options = computed(() => props.categoriesTree || [])
const level2Options = computed(() => {
  if (!filters.catLevel1Id || !props.categoriesTree) return []
  const parent = props.categoriesTree.find(c => String(c.id_categorie) === String(filters.catLevel1Id))
  return parent?.children || []
})
const level3Options = computed(() => {
  if (!filters.catLevel2Id || !level2Options.value.length) return []
  const parent = level2Options.value.find(c => String(c.id_categorie) === String(filters.catLevel2Id))
  return parent?.children || []
})

watch(() => filters.catLevel1Id, (newVal) => {
  filters.catLevel2Id = ''
  filters.catLevel3Id = ''
  filters.categories = String(newVal || '')
})

watch(() => filters.catLevel2Id, (newVal) => {
  filters.catLevel3Id = ''
  filters.categories = String(newVal || filters.catLevel1Id || '')
})

watch(() => filters.catLevel3Id, (newVal) => {
  filters.categories = String(newVal || filters.catLevel2Id || filters.catLevel1Id || '')
})

const filteredProducts = computed(() => {
  let filtered = props.products

  if (filters.reference) {
    filtered = filtered.filter(p =>
        p.reference.toLowerCase().includes(filters.reference.toLowerCase())
    )
  }

  if (filters.marque) {
    filtered = filtered.filter(p =>
        p.marque === filters.marque
    )
  }

  if (filters.collection) {
    filtered = filtered.filter(p =>
        p.collection === filters.collection
    )
  }

  if (filters.categories) {
    const selectedId = Number(filters.categories)
    filtered = filtered.filter(
        p =>
            p.catLevel1Id === selectedId ||
            p.catLevel2Id === selectedId ||
            p.catLevel3Id === selectedId
    )
  }

  if (filters.prixMin) {
    filtered = filtered.filter(p => p.prix >= parseFloat(filters.prixMin))
  }

  if (filters.prixMax) {
    filtered = filtered.filter(p => p.prix <= parseFloat(filters.prixMax))
  }

  if (filters.statut) {
    filtered = filtered.filter(p => p.statut === filters.statut)
  }

  if (filters.remise === 'remise') {
    filtered = filtered.filter(p =>
        p.prixReduit != null && p.prixReduit > 0 && p.prixReduit < p.prix)
  } else if (filters.remise === 'plein-tarif') {
    filtered = filtered.filter(p =>
        !(p.prixReduit != null && p.prixReduit > 0 && p.prixReduit < p.prix))
  }

  if (filters.dateFrom || filters.dateTo) {
    const from = filters.dateFrom ? new Date(filters.dateFrom) : null
    const to = filters.dateTo ? new Date(filters.dateTo) : null

    filtered = filtered.filter(p => {
      if (!p.date) return false
      const d = new Date(p.date as any)
      if (Number.isNaN(d.getTime())) return false

      if (from && d < from) return false

      if (to) {
        const endOfDay = new Date(to)
        endOfDay.setHours(23, 59, 59, 999)
        if (d > endOfDay) return false
      }
      return true
    })
  }

  return filtered
})

// Debounce server-side filtering to avoid excessive requests and improve UX
let filterDebounceTimer: number | undefined
watch(
  filters,
  () => {
    // Immediate update for local filtering
    emit('update:filtered-products', filteredProducts.value)
    // Debounced server notification
    if (filterDebounceTimer) window.clearTimeout(filterDebounceTimer)
    filterDebounceTimer = window.setTimeout(() => {
      emit('filter', { ...filters })
    }, 400)
  },
  { deep: true }
)

const handleFilter = async () => {
  isFiltering.value = true
  await new Promise(resolve => setTimeout(resolve, 500))
  emit('update:filtered-products', filteredProducts.value)
  emit('filter', { ...filters })
  isFiltering.value = false
}

// Computed property to check if any filter is active
const hasActiveFilters = computed(() => {
  return Object.entries(filters).some(([key, value]) => {
    if (key === 'tri') return value !== 'date'
    return value !== null && value !== undefined && value !== ''
  })
})

const clearFilters = () => {
  filters.reference = ''
  filters.marque = ''
  filters.collection = ''
  filters.categories = ''
  filters.catLevel1Id = ''
  filters.catLevel2Id = ''
  filters.catLevel3Id = ''
  filters.prixMin = ''
  filters.prixMax = ''
  filters.statut = ''
  filters.dateFrom = ''
  filters.dateTo = ''
  filters.tri = 'date'
  filters.remise = ''

  emit('update:filtered-products', props.products)
  emit('filter', { ...filters })
}

// Charger les marques et collections
const loadBrands = async () => {
  try {
    // Vérifier que l'authentification est initialisée
    if (!authStore.isInitialized) {
      await authStore.checkAuth()
    }
    
    // Vérifier que l'utilisateur est authentifié
    if (!authStore.isAuthenticated || !authStore.user?.id_vendeur) {
      brands.value = []
      return
    }
    
    brands.value = await getVendeurMarques()
  } catch (error) {
    brands.value = []
  }
}

const loadCollections = async () => {
  try {
    collections.value = await getCollections('fr')
  } catch (error) {
    collections.value = []
  }
}

// Gérer le collapse en fonction de la largeur de l'écran
let resizeHandler: (() => void) | null = null

onMounted(async () => {
  // Charger les marques et collections
  await Promise.all([loadBrands(), loadCollections()])
    // Initialize filters from props.initialFilters if provided
    if (props.initialFilters) {
      const init = props.initialFilters
      if (init.reference != null) filters.reference = String(init.reference)
      if (init.marque != null) filters.marque = String(init.marque)
      if (init.collection != null) filters.collection = String(init.collection)
      if (init.categories != null) filters.categories = String(init.categories)
      if (init.catLevel1Id != null) filters.catLevel1Id = String(init.catLevel1Id)
      if (init.catLevel2Id != null) filters.catLevel2Id = String(init.catLevel2Id)
      if (init.catLevel3Id != null) filters.catLevel3Id = String(init.catLevel3Id)
      if (init.prixMin != null) filters.prixMin = String(init.prixMin)
      if (init.prixMax != null) filters.prixMax = String(init.prixMax)
      if (init.statut != null) filters.statut = String(init.statut)
      if (init.dateFrom != null) filters.dateFrom = String(init.dateFrom)
      if (init.dateTo != null) filters.dateTo = String(init.dateTo)
      if (init.tri != null) filters.tri = String(init.tri)
      if (init.remise != null) filters.remise = String(init.remise)
      // Emit once to inform parent of initial state
      emit('filter', { ...filters })
    }
  
  let lastWidth = window.innerWidth
  isCollapsed.value = lastWidth < 768

  resizeHandler = () => {
    const newWidth = window.innerWidth
    if (newWidth !== lastWidth) {
      lastWidth = newWidth
      isCollapsed.value = newWidth < 768
    }
  }
  window.addEventListener('resize', resizeHandler)
})

onUnmounted(() => {
  if (resizeHandler) {
    window.removeEventListener('resize', resizeHandler)
  }
  if (filterDebounceTimer) window.clearTimeout(filterDebounceTimer)
})
</script>
